<template>
  <div class="productPag tinyScreenProductPagDetail" id="tinyScreenProductPagDetail">
    <Header></Header>
    <!-- banner -->
    <div class="bannerHeaderBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30 phonePic" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>
    <!-- <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <span>佳期旗下产品</span>
          <img width="300px" src="../../assets/picture/product/list1.png">
        </div>
        <img class="fr mt30" width="300px" src="../../assets/picture/product/t12.png">
      </div>
    </div> -->
    <!-- section1 -->
    <div class="section1 middle">
      <div class="container">
        <div class="crumbs">
          <span @click="goList">产品类别</span>
          <span><img src="../../assets/picture/occupation/more.png"></span>
          <span>{{detail.productFullName}}</span>
        </div>
        <p class="title">{{detail.productFullName}}</p>
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
          <el-tab-pane label="基金概况" class="firstSection" name="first">
              <ul>
                <li>产品名称：<span>{{detail.productFullName}}</span></li>
                <li>
                  <span class="subPart">产品分类：<span>{{typeName?typeName:'--'}}</span></span>
                  <span class="subPart pcShow">产品简称：<span>{{detail.productName}}</span></span>
                </li>
                <li class="phoneShow">
                  产品简称：<span>{{detail.productName}}</span>
                </li>
                <li>
                  成立日期：<span>{{detail.createTime | format}}</span>
                </li>
              </ul>
          </el-tab-pane>
          <el-tab-pane label="产品报表" name="second" class="sectionSection">
            <template>
              <ul>
                <li v-for="(item,index) in productList" :key="index">
                  <div class="loadBtn pcShow" @click="loadFile(item)">
                    下载
                  </div>
                   <div class="loadBtn phoneShow" @click="loadFile(item)">
                    <img class="fr mt30" width="300px" src="../../assets/picture/product/load.png">
                  </div>
                  <div class="txt pcShow">
                    {{item.title}}
                  </div>
                  <!-- <div class="date fr pcShow">
                    {{item.createTime | getDate}}
                  </div> -->
                  <div class="phoneShow">
                    <div class="txt">
                      {{item.title}}
                    </div>
                    <!-- <div class="date">
                      {{item.createTime | getDate}}
                    </div> -->
                  </div>
                </li>
              </ul>
              <!-- 
              <el-pagination class="pagination"
            layout="prev, pager, next"
            :total="50">
          </el-pagination> -->
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import {format} from '../../plugins/formatDate.js'
export default {
  data() {
    return {
      id:'',
      liIndex:-1,
      activeName2:'first',
      isShowSearch:false,
      detail:{},
      typeName:'',
      lang:'',
      bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      },
      productList:[],
    };
  },
  components: { Header,Footer },
  mounted(){
    this.getAdvert();
    this.id = this.$route.query.id;
    this.getProductById();
    this.getAllProductType(this.id);
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
  },
   filters: {
      format(time) {
        return format(time)
      }
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    loadFile(item){
      let url = JSON.parse(item.attachmentUrl);
       window.open(url.attachments[0]);
    },  
    goList(){
       // this.$router.push({  
       //      path: '/productList',       
       //  })
    },
     handleClick(tab, event) {
        console.log(tab, event);
    },
      //获取所有产品分类信息
     async getAllProductType(id) {
         const { data: res } = await this.$http.get("/product/getAllProductType.do");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        let list = res.data;
        list.forEach(e=>{
          if(e.id == id){
            this.typeName = e.typeName;
          }
        })
    },
     //根据ID获取产品
     async getProductById() {
         const { data: res } = await this.$http.get("/product/getProductById.do?id="+this.id);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
       this.detail = res.data;
       this.productList = res.data.reportList;
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=18");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
  }
};
</script>

<style lang="less" scoped>
.productPag{
  .bannerHeaderBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{      
        margin-top: 50px;
      }
    }
  }
  /*********************************************/
  .section1{
    padding-bottom: 193px;
    .crumbs{
      padding:40px 0 14px 0;
      border-bottom: 1px solid #D5D5D5;
      display: block;
      cursor: pointer;
      span{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
        line-height: 28px;
        letter-spacing: 1px;
        margin-right: 23px;
        img{
          width: 14px;
          height: 14px;
          margin:0 23px;
        }
      }
    }
    .title{
      padding:37px 0 52px 0;
      text-align: center;
      font-size: 35px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #900211;
      line-height: 49px;
      letter-spacing: 2px;
    }
    .firstSection{
      ul{
        li{
          display: flex;
          padding:30px 0 30px 60px;
          width: 100%;
          border-bottom: 2px solid #F2F2F2;
          .subPart{
            width: 50%;
            margin-left: 0;
          }
          span{
            margin-left: 30px;
          }
        }
      }
    }
    .sectionSection{
      .pagination{
      text-align: center;
      margin-top: 55px;
      /deep/ .el-pager li.active{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
      }
      /deep/ .el-pager li{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9A9A9A;
      }
    }
      ul{
        li{
          padding:18px 0;
          display: flex;
          position: relative;
          .loadBtn{
            width: 102px;
            height: 44px;
            border: 1px solid #900211;
            line-height: 44px;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #900211;
            cursor: pointer;
            margin-right: 36px;
          }
          .txt{
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #353535;
            line-height: 20px;
          }
          .date{
            position: absolute;
            right: 78px;
            top:30px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353535;
            line-height: 20px;
          }
        }
      }
    }
    /deep/ .el-tabs__item{
      width: 216px;
      height: 60px;
      background: #D6D6D6;
      color: #fff;
      text-align: center;
      line-height: 60px;
    }
    /deep/ .el-tabs--card>.el-tabs__header{
      border-bottom: 2px solid #900211;
  /*    z-index:999;*/
    }
    /deep/ .el-tabs__item.is-active{
      width: 216px;
      height: 60px;
      background: #900211;
      color: #fff;
      text-align: center;
      line-height: 60px;
    }
  }
}
</style>
